import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useSpotlight, STANCOR_PATH } from "@/components/SpotlightSection";

/** One quiet line on every page naming the group's anchor partner. */
export const SpotlightFooterLine = () => {
  const { t } = useLang();
  const s = useSpotlight("show_footer");
  if (!s) return null;

  return (
    <div className="border-t border-border bg-primary/[0.03]" data-testid="spotlight-footer">
      <Link
        to={s.show_page === false ? "/joint-ventures" : STANCOR_PATH}
        data-testid="spotlight-footer-link"
        className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-2 px-5 py-5 text-center transition-colors hover:bg-primary/[0.06] sm:px-8"
      >
        <span className="text-[10px] font-bold uppercase tracking-[0.24em] text-muted-foreground">
          {t("spotlight_footer")}
        </span>
        <span className="flex items-center gap-2.5">
          {s.logo ? <img src={s.logo} alt="" className="h-7 w-7 rounded-md object-contain" /> : null}
          <span className="font-head text-lg text-primary">{s.name}</span>
        </span>
      </Link>
    </div>
  );
};

export default SpotlightFooterLine;
